import { useRoutes } from "react-router-dom"
import Notfound from "../views/Notfound";
import AdminLayout from "../componnent/AdminLayout";
import ClientLayout from "../componnent/ClientLayout";
import PrintInvoice from "../views/Invoice/PrintInvoice";
import PayInvoice from "../views/Invoice/PayInvoice";
import ExportInvoice from "../views/Invoice/EportInvoice";
import CheckoutInvoice from "../views/Invoice/CheckoutInvoice";

const ThemeRoutes = () => {
    return useRoutes([
        {
            path: "/admin",
            element: <AdminLayout />,
            children: [
                {
                    path: "invoice",
                    element: "ss"
                }
            ]
        },
        {
            path: "/invoice",
            element: <ClientLayout />,
            children: [
                {
                    path: "pr",
                    element: <PrintInvoice />
                },
                {
                    path: "py",
                    element: <PayInvoice />
                },
                {
                    path: "export",
                    element: <ExportInvoice />
                },
                {
                    path: "checkout",
                    element: <CheckoutInvoice />
                }
            ]
        },
        {
            path: "*",
            element: <Notfound />
        }
    ])
}

export default ThemeRoutes;